// For full API documentation, including code examples, visit https://wix.to/94BuAAs

$w.onReady(function () {
	// TODO: write your page related code here...

	$w('#text53').onMouseIn(()=>{hoverTxt('#text53');});
	$w('#text53').onMouseOut(()=>{unhoverText('#text53');});
	$w('#text51').onMouseIn(()=>{hoverTxt('#text51');});
	$w('#text51').onMouseOut(()=>{unhoverText('#text51');});
	$w('#text52').onMouseIn(()=>{hoverTxt('#text52');});
	$w('#text52').onMouseOut(()=>{unhoverText('#text52');});


	function hoverTxt(selector){
	let oldHtmlStr = $w(selector).html;
	let newHtmlStr = oldHtmlStr.replace(/#3F3F3F/i, '#FF6600');
	console.log(newHtmlStr);
	$w(selector).html = newHtmlStr;
}

function unhoverText(selector){
	let oldHtmlStr = $w(selector).html;
	let newHtmlStr = oldHtmlStr.replace(/#FF6600/i, '#3F3F3F');
	console.log(newHtmlStr);
	$w(selector).html = newHtmlStr;
}
})